<app-kontable
        #table
        id="dt_roles"
        *ngIf="mainTable"
        [title] = "'roleMS.sectionTitle' | translate"
        [columns] = "[
        { field: 'application', filterTemplate: operationFilter, title: 'common.application', filterType: customFilter },
        'id', 'description']"
        [titles] = "['common.id_rule', 'common.description']"
        [source] = "srvRoleMS.roleMS"
        [paginationType]="paginationType"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showInfoButton]="false"
        [showAddButton]="true"
        [(fireNewDataAvailable)]="newDataAvailable"
        [additionalRowCommands]="customRow"
        (onAdd)="editRole(null)"
        (onEdit)="editRole($event)"
        (onRemove)="remove($event)">

    <ng-template #operationFilter data-testid="operationFilter" let-col>
        <p-dropdown [options]="applicationDropdown" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
    </ng-template>

    <ng-template #customRow data-testid="customRow" let-row>
        <p-button label="" pTooltip="{{ 'roleMS.usersSectionTitle' | translate }}" icon="fa fa-user" styleClass="ui-button-info" (onClick)="customButton(row, 'users')"></p-button>
        <p-button label="" pTooltip="{{ 'roleMS.permissionsSectionTitle' | translate }}" icon="fa fa-key" styleClass="ui-button-info" (onClick)="customButton(row, 'permissions')"></p-button>
    </ng-template>

</app-kontable>

<p-dialog
        *ngIf="showDetail"
        [width]="600"
        [(visible)]="showDetail"
        [responsive]="true"
        [draggable]="false"
        [resizable]="false"
        showEffect="fade"
        header="{{modalTitle}}"
        (onHide)="closeDialogDetail()"
        [modal]="true">

        <app-rolesapplication-form
                *ngIf="showDetail"
                (onSave)="save($event)"
                [role]="selectedRoleMS"
        ></app-rolesapplication-form>
</p-dialog>


<app-rolesapplication-users
        *ngIf="showUsers && selectedRoleEdit"
        [role]="selectedRoleEdit"
        (onBack)="returnToMain()"
></app-rolesapplication-users>

<app-rolesapplication-permissions
        *ngIf="showPermissions && selectedRoleEdit"
        [role]="selectedRoleEdit"
        (onBack)="returnToMain()"
></app-rolesapplication-permissions>



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplication.component.html